import { render, staticRenderFns } from "./ReporteResumenGeneral.vue?vue&type=template&id=de533fba&"
import script from "./ReporteResumenGeneral.vue?vue&type=script&lang=js&"
export * from "./ReporteResumenGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports